export default __webpack_public_path__ + "static/media/Paolo Rumiz e Emilio Rigatti.47d74d5b.jpg";